import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, message, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import React, { useState } from "react";
import { ContentPartFilter } from "../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../components/page-header";
import { EmptyData } from "../../../components/empty/emptyData";
import { AddRealEstateModal } from "./AddRealEstate";
import { useRealEstate } from "./useRealEstate";
import { FilterRealEstate } from "./FilterRealEstate";
import { EntRealEstateFilter } from "../../../models/filters/realEstateFilter";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import i18n from "i18next";
import { EntRealEstate } from "../../../models/realEstate";
import {
  useGetReportRealEstateMutation,
  useLazyGetRealEstateListAllQuery
} from "../../../redux/api/realEstate/realEstateApi";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/root/root-state.interface";

enum FormField {
  periodStart,
  periodEnd,
  governments,
}

export const RealEstateRegister = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntRealEstate>(new EntRealEstate());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation();
  const authState = useSelector((state: RootState) => state.authSlice);

  const [getRealEstateReport] = useGetReportRealEstateMutation();
  const [getRealEstateFolders] = useLazyGetRealEstateListAllQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntRealEstate, EntRealEstateFilter>({
	initialFilter: new EntRealEstateFilter(),
	query: getRealEstateFolders
  });

  const { onAddRealEstate, onEditRealEstate, onDeleteRealEstate } = useRealEstate(modal, () => {
	searchHandleClick();
  })
  const [height, setHeight] = useState<number>(0);

  const storedData = JSON.parse(localStorage.getItem("availableRoutes") || "[]");
  const isReportAvailable = storedData.some((route: any) => (route.alias === "/report" || route.alias === "/interactive-map-ws") && route.methodPost);

  const openAddModal = (item: EntRealEstate) => {
	setSelectedItem(item);
	setShowModal(true);
  }

  const setEntityFromFields = (): EntRealEstateFilter => {
	let filt: EntRealEstateFilter = _.clone(filter);
	filt.periodStart = form.getFieldValue(FormField.periodStart) ?? null;
	filt.periodEnd = form.getFieldValue(FormField.periodEnd) ?? null;
	filt.governmentIds = form.getFieldValue(FormField.governments) ?? null;
	filt.page = 1;
	return filt;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.periodStart, value: null },
	  { name: FormField.periodEnd, value: null },
	  { name: FormField.governments, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const handleSubmit = async () => {
	try {
	  const payload = {
		governmentAlias: authState.governmentAlias,
		language: i18n.language,
	  };

	  const result = await getRealEstateReport(payload);

	  if ('data' in result) {
		const blob = result.data;
		const url = window.URL.createObjectURL(blob);
		const link = document.createElement("a");
		link.href = url;
		link.setAttribute("download", `Report_${ dayjs().format("YYYY-MM-DD") }.xlsx`);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

		message.success(t('reports.download_success'));
	  } else {
		throw new Error(t('reports.download_failed'));
	  }
	} catch (error: any) {
	  Modal.error({
		title: t("msg.error"),
		content: error.message || t('reports.download_failed'),
	  });
	}
  };

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('mts.name_organizations') }</th>
		  <th>{ t('titles.type_objects') }</th>
		  <th>{ t('general.squares') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 5 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.length !== 0 ? data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ i18n.language === 'ru' ? item?.government?.nameRu : item?.government?.nameKy }</td>

			<td>{ i18n.language === 'ru' ? item?.typeObject?.nameRu : item?.typeObject?.nameKy }</td>
			<td>{ item.square } </td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteRealEstate(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) : <tr>
		  <td colSpan={ 5 }>
			<EmptyData/>
		  </td>
		</tr> }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('real_estate_register') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('general.records_found') } { totalItems }</Typography.Text>
		}/>
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntRealEstate())
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  { isReportAvailable && (
	  <Button style={ { marginLeft: '5px' } } type="primary" icon={ <PlusOutlined/> } onClick={ () => handleSubmit() }>
		{ t('reports.download_report') }
	  </Button>
		)}
	  <ContentPartFilter
		filter={ <FilterRealEstate onSearch={ searchHandleClick }
								   onReset={ () => {
									 clearFields();
									 searchHandleClick()
								   } } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }
	  />

	  <AddRealEstateModal
		realEstate={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		  setSelectedItem(new EntRealEstate())
		} }
		onSubmit={ selectedItem.id !== null ? onEditRealEstate : onAddRealEstate }
	  />
	  { contextHolder }
	</>
  )
}
